// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Property__Components = require("../../../reason/clients/components/Property/Property__Components.bs.js");

function getMlsPreviewErrorMessages(mlsListingTypeValid, onMlsAtValid, onEditForm) {
  var mlsListingTypeError;
  if (mlsListingTypeValid !== undefined && typeof mlsListingTypeValid === "object") {
    var e = mlsListingTypeValid.VAL;
    mlsListingTypeError = Caml_option.some(JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
              text: e === "alreadyOnMlsAndNotActive" ? "Property must be marked as Active on MLS" : (
                  e === "required" ? "MLS listing type required" : "Property has an invalid MLS status"
                ),
              className: "!max-w-full",
              onClick: (function (param) {
                  onEditForm("mlsTiming");
                })
            }));
  } else {
    mlsListingTypeError = undefined;
  }
  var onMlsAtError;
  if (onMlsAtValid !== undefined && typeof onMlsAtValid === "object") {
    var e$1 = onMlsAtValid.VAL;
    onMlsAtError = Caml_option.some(JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
              text: e$1 === "required" ? "Expected on MLS date required" : (
                  e$1 === "alreadyOnMlsAndAfterToday" ? "Expected on MLS date must be before today when the property is already on MLS" : "Expected on MLS date must be after today"
                ),
              className: "!max-w-full",
              onClick: (function (param) {
                  onEditForm("mlsTiming");
                })
            }));
  } else {
    onMlsAtError = undefined;
  }
  if (mlsListingTypeError === undefined && onMlsAtError === undefined) {
    return ;
  }
  return Caml_option.some(JsxRuntime.jsxs("div", {
                  children: [
                    Core__Option.getOr(mlsListingTypeError, null),
                    Core__Option.getOr(onMlsAtError, null)
                  ],
                  className: "my-2 flex flex-col gap-2"
                }));
}

exports.getMlsPreviewErrorMessages = getMlsPreviewErrorMessages;
/* react/jsx-runtime Not a pure module */
